/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Shipping_Adjustment_DescriptionInputs */

const en_create_shipping_adjustment_description = /** @type {(inputs: Create_Shipping_Adjustment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust the shipping charge for an active order`)
};

const es_create_shipping_adjustment_description = /** @type {(inputs: Create_Shipping_Adjustment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta el cargo de envio para un pedido activo`)
};

/**
* | output |
* | --- |
* | "Adjust the shipping charge for an active order" |
*
* @param {Create_Shipping_Adjustment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_shipping_adjustment_description = /** @type {((inputs?: Create_Shipping_Adjustment_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Shipping_Adjustment_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_shipping_adjustment_description(inputs)
	return es_create_shipping_adjustment_description(inputs)
});